import { DealType, Dsp } from 'components/common/types/Deal.types';

export const isDspSupportingSync = (dsp: Dsp | null | undefined, dspsThatSupportSync: string[]): boolean =>
  !!dsp && dspsThatSupportSync.includes(dsp.code);

export const isDspSupportingBidstream = (
  dsp: Dsp | null | undefined,
  dealType: DealType,
  dspsThatSupportBidstream: string[],
): boolean => !!dsp && dealType !== DealType.GUARANTEED && dspsThatSupportBidstream.includes(dsp.code);
